import { useNavigate, useParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';

import { appPublicPath, appRunPath } from '../../utils/constants';
import { Run } from '../Run';

export const PublicRun = () => {
  const { shareToken, runId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen flex-col px-4 pt-4">
      <Breadcrumbs />
      <div className="-mx-4 mt-4 h-[1px] flex-shrink-0 bg-tertiary" />
      <Run
        runId={runId}
        shareTokenProp={{ runShareToken: shareToken }}
        navigateToRun={(run_id: string) => {
          navigate(`/${appPublicPath}/${shareToken}/${appRunPath}/${run_id}`);
        }}
      />
    </div>
  );
};
